import * as StellarSdk from 'stellar-sdk'

export const KuknosServer = new StellarSdk.Server(
    process.env.REACT_APP_HORIZON_URL as string
)

export const KuknosSdk = StellarSdk
